//  Libraries
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import { translate } from 'react-i18next';
import validator from 'validator';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';

const classPrefix = 'registration-modal';

export class RegistrationModal extends React.Component {
    constructor(props) {
        super(props);
        const {attendeeInfo} = this.props;
        this.state = {
            showModal: true,
            firstName: attendeeInfo && attendeeInfo.webinarAttendeeInfo && attendeeInfo.webinarAttendeeInfo.attendeeFirstName ? attendeeInfo.webinarAttendeeInfo.attendeeFirstName : '',
            lastName: attendeeInfo && attendeeInfo.webinarAttendeeInfo && attendeeInfo.webinarAttendeeInfo.attendeeLastName ? attendeeInfo.webinarAttendeeInfo.attendeeLastName : '',
            email: attendeeInfo && attendeeInfo.webinarAttendeeInfo && attendeeInfo.webinarAttendeeInfo.attendeeEmail ? attendeeInfo.webinarAttendeeInfo.attendeeEmail : '',
            touched: {
                firstName: false,
                lastName: false,
                email: false
            }
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    close() {
        this.setState({ showModal: false });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    handleSubmit() {
        const regDetails = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email
        };
        return this.props.registrationData(regDetails);
    }

    validateInput(firstName, lastName, email) {
        return {
            firstName: firstName.trim().length === 0,
            lastName: lastName.trim().length === 0,
            email: !validator.isEmail(email)
        };
    }

    loginOptions(platform) {
        const baseUrl = window.location.href.split('?')[0];
        if (platform === 'corporate') {
            mixpanelTracker.track(`${mixpanelTracker.wnPage}:${mixpanelTracker.registrationModal}-${mixpanelTracker.valueCorporate} ${mixpanelTracker.valueCicked}`);
            window.location.href = `${baseUrl}?login=corporate&tos=true`;
        } else if (platform === 'linkedin') {
            mixpanelTracker.track(`${mixpanelTracker.wnPage}:${mixpanelTracker.registrationModal}-${mixpanelTracker.valueLinkedin} ${mixpanelTracker.valueCicked}`);
            window.location.href = `${baseUrl}?login=linkedin&tos=true`;
        } else if (platform === 'facebook') {
            mixpanelTracker.track(`${mixpanelTracker.wnPage}:${mixpanelTracker.registrationModal}-${mixpanelTracker.valueFacebook} ${mixpanelTracker.valueCicked}`);
            window.location.href = `${baseUrl}?login=facebook&tos=true`;
        } else if (platform === 'google') {
            mixpanelTracker.track(`${mixpanelTracker.wnPage}:${mixpanelTracker.registrationModal}-${mixpanelTracker.valueGooglePlus} ${mixpanelTracker.valueCicked}`);
            window.location.href = `${baseUrl}?login=google&tos=true`;
        }
    }

    getRegistrationForm() {
        const {t} = this.props;
        const {firstName, lastName, email} = this.state;
        const errors = this.validateInput(firstName, lastName, email);
        const isDisabled = Object.keys(errors).some(x => errors[x]);

        const shouldMarkError = (field) => {
            const hasError = errors[field];
            const shouldShow = this.state.touched[field];
            return hasError ? shouldShow : false;
        };

        return (
            <form className={`${classPrefix}-formGroup`}>
                <div className="form-group">
                    <div className="control-block">
                        <input
                          className={`form-control ${shouldMarkError('firstName') ? 'input-error' : ''}`}
                          name="firstName"
                          type="text"
                          placeholder="* First Name"
                          value={this.state.firstName}
                          onChange={this.handleInputChange}
                          onBlur={this.handleBlur('firstName')}
                          maxLength="128"
                        />
                        <input
                          className={`form-control ${shouldMarkError('lastName') ? 'input-error' : ''}`}
                          name="lastName"
                          type="text"
                          placeholder="* Last Name"
                          value={this.state.lastName}
                          onChange={this.handleInputChange}
                          onBlur={this.handleBlur('lastName')}
                          maxLength="128"
                        />
                        <div>
                            <input
                              className={`form-control ${shouldMarkError('email') ? 'input-error' : ''}`}
                              name="email"
                              type="email"
                              placeholder="* Email Address"
                              value={this.state.email}
                              onChange={this.handleInputChange}
                              onBlur={this.handleBlur('email')}
                              maxLength="128"
                            />
                            <span className={shouldMarkError('email') ? 'email-err-msg' : 'hide'}>{t('registrationModal.errors.email-error')}</span>
                        </div>

                        <div className={`${classPrefix}_button`}>
                            <Button disabled={isDisabled} onClick={this.handleSubmit.bind(this)}>{t('registrationModal.register-btn')}</Button>
                        </div>
                    </div>
                </div>
            </form>
      );
    }

    getLoginOptions() {
        const {t} = this.props;
        return (
            <div className={`${classPrefix}-loginOption`}>
                <Button className="corporate-btn" onClick={this.loginOptions.bind(this, 'corporate')}>
                    <span className="g2w-icon"><i className="togo-icon togo-icon-gotomeeting togo-icon-2x"></i></span>
                    <span>{t('registrationModal.register-btn-cor')}</span>
                </Button>
                <Button className="linkedin-btn" onClick={this.loginOptions.bind(this, 'linkedin')}>
                    <img src={`${config.assets.url}/images/watch-now/registration-modal/linkedIn.png`} alt="" />
                    <span>{t('registrationModal.register-btn-lin')}</span>
                </Button>
                <Button className="facebook-btn" onClick={this.loginOptions.bind(this, 'facebook')}>
                    <img src={`${config.assets.url}/images/watch-now/registration-modal/facebook.png`} alt="" />
                    <span>{t('registrationModal.register-btn-fb')}</span>
                </Button>
                <Button className="google-btn" onClick={this.loginOptions.bind(this, 'google')}>
                    <img src={`${config.assets.url}/images/watch-now/registration-modal/google.png`} alt="" />
                    <span>{t('registrationModal.register-btn-goo')}</span>
                </Button>
            </div>
      );
    }

    getRegistrationTerms() {
        const {t} = this.props;
        return (
            <div className={`${classPrefix}-terms`}>
                {t('registrationModal.register-terms-1a')}
                <a href={`${config.company.privacyPolicy}`} target="_blank" rel="noopener">{t('registrationModal.register-terms-1b')}</a>
                {t('registrationModal.register-terms-1c')}
                <a href={`${config.company.termsOfService}`} target="_blank" rel="noopener">{t('registrationModal.register-terms-1d')}</a>
                {t('registrationModal.register-terms-1e')}
            </div>
      );
    }

    render() {
        const {t} = this.props;
        return (
            <Modal dialogClassName={`${classPrefix}-dialog modal-container`} show={this.state.showModal} onHide={this.close.bind(this)} onExited={this.props.onExited}>
                <Modal.Header closeButton>
                    <Modal.Title bsClass={`${classPrefix}-title`}>{t('registrationModal.register-now')}</Modal.Title>
                    <div className={`${classPrefix}-subtitle`}>{t('registrationModal.register-methods')}</div>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={5} sm={5}>
                          {this.getLoginOptions()}
                        </Col>
                        <Col md={7} sm={7}>
                          {this.getRegistrationForm()}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                  {this.getRegistrationTerms()}
                </Modal.Footer>
            </Modal>
        );
    }
}

RegistrationModal.propTypes = {
    onExited: PropTypes.func,
    t: PropTypes.func,
    registrationData: PropTypes.func,
    attendeeInfo: PropTypes.object
};

export default translate(['translation'])(RegistrationModal);



// WEBPACK FOOTER //
// ./src/components/watch-now/registration-modal.js